module.exports = __webpack_public_path__ + "img/IMG_1444_L_Foamcore_MockedUp.ed35ca81.jpg";